import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HelperService } from '../shared/helper/helper.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {

  private _controller = 'auth/';

  constructor(private _http: HttpClient, private _helper: HelperService, private _router: Router) { }

  login(formData: any): Observable<Object>{
    return this._http.post<Object>(this._controller + 'login', formData);
  }

  getToken(): Observable<Object>{
    let formData = {'refreshToken': this._helper.refreshToken.get()};
    return this._http.post<Object>(this._controller + 'token', formData);
  }

  logout(){
    this._helper.token.remove();
    this._helper.refreshToken.remove();
    this._helper.user.remove();
    this._router.navigate(['/auth/login']);
  }

}
